// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface push_space_args {
    separator: string;
    splitFractionToPart?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Number {
    minmax: (min: number, max: number) => number
    push_space(args?: push_space_args): string
    getFixedOne: () => any
    short: (...without: number[]) => string
    declension: (...declensions: string[]) => string
}

// @ts-expect-error
// eslint-disable-next-line no-extend-native
Number.prototype.minmax = function (min, max) {
    return this < min ? min : this > max ? max : this
}

// eslint-disable-next-line no-extend-native
// Number.prototype.push_space = function () {
//     return (
//         this.toString()
//         .reverse()
//         .match(/.{1,3}/g) as RegExpMatchArray
//     ).join(' ')
//     .reverse()
// }

// eslint-disable-next-line no-extend-native
Number.prototype.push_space = function ({
    separator,
    splitFractionToPart
} = {
    separator: ' ',
    splitFractionToPart: true
}) {
    const [integerPart, fractionPart] = this.toString().split('.');

    // Форматируем целую часть
    const formattedInteger = new Intl.NumberFormat().format(Number(integerPart));

    // Обрабатываем дробную часть, если это требуется
    const formattedFraction = splitFractionToPart && fractionPart
        ? fractionPart.match(/.{1,3}/g)?.join(' ')
        : fractionPart;

    return (
        formattedFraction
            ? `${formattedInteger}.${formattedFraction}`
            : formattedInteger
    ).replaceAll(',', separator);
};

const divider_obj = {
    1_000_000_000: ' млрд.',
    1_000_000: ' млн.',
    1: ''
}

function getShortDivider (num: number, ...without: number[]) {
    const result = [
        1000000000,
        1000000,
        1
    ]
        .filter(
            divider => !without.includes(divider)
        )
        .find(
            divider => num >= divider
        ) ?? 1
    console.log('some_divider', result)
    return result
}

// eslint-disable-next-line no-extend-native
Number.prototype.getFixedOne = function () {
    // @ts-expect-error
    return parseInt(String((this) * 10)) / 10
}

// eslint-disable-next-line no-extend-native
Number.prototype.short = function (...without: number[]) {
    const some_divider = getShortDivider(+this, ...without)
    // @ts-expect-error
    if (divider_obj[some_divider] === '') {
        return this.push_space()
    } else {
        // @ts-expect-error
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return (this / some_divider).getFixedOne() + divider_obj[some_divider]
    }
}

// eslint-disable-next-line no-extend-native
Number.prototype.declension = function (...declensions: string[]) {
    return declensions[
        // @ts-expect-error
        this % 100 > 4 && this % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][this % 10 < 5 ? this % 10 : 5]
    ]
}

// seconds.declension(['секунда', 'секунды', 'секунд'])
// minutes.declension(['минута', 'минуты', 'минут'])
// hours.declension(['час', 'часа', 'часов'])
// days.declension(['день', 'дня', 'дней'])
// weeks.declension(['неделя', 'недели', 'недель']);
// months.declension(['месяц', 'месяца', 'месяцев']);
// years.declension(['год', 'года', 'лет']);
